'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styling = require('@rexlabs/styling');

var _styleMixins = require('../../utils/style-mixins');

var _styleMixins2 = _interopRequireDefault(_styleMixins);

var _customPropTypes = require('../../utils/custom-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinnerIcon = function SpinnerIcon(props) {
  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({}, props, { viewBox: '0 0 16 16' }),
    _react2.default.createElement('path', { d: 'M4.8 12.6c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.8-.3s-.3-.5-.3-.8c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3s.6.1.8.3c.2.2.3.5.3.8zm4.3 1.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8 0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.3 0 .6.1.8.3.2.2.3.5.3.8zM3 8.3c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3s-.6-.1-.8-.3c-.2-.3-.3-.5-.3-.8 0-.3.1-.6.3-.8s.5-.3.8-.3.6.1.8.3c.2.2.3.5.3.8zm10.4 4.3c0 .3-.1.6-.3.8s-.5.3-.8.3c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8s.1-.6.3-.8c.2-.2.5-.3.8-.3.3 0 .6.1.8.3.2.2.3.5.3.8zM5.1 4c0 .4-.1.7-.4 1-.3.3-.6.4-1 .4s-.7-.2-1-.5-.4-.6-.4-.9.1-.7.4-1c.3-.3.6-.4 1-.4s.7.1 1 .4c.2.2.4.6.4 1zm10.1 4.3c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.8-.3-.2-.3-.3-.5-.3-.8 0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.3 0 .6.1.8.3.2.2.3.5.3.8zM9.7 2.2c0 .5-.2.9-.5 1.2-.3.3-.7.4-1.2.4s-.9-.2-1.2-.5c-.3-.3-.5-.7-.5-1.1s.2-.9.5-1.2C7.1.7 7.5.5 8 .5s.9.2 1.2.5c.3.3.5.7.5 1.2zM14.3 4c0 .5-.2 1-.6 1.4-.4.4-.8.6-1.4.6-.5 0-1-.2-1.4-.6-.3-.4-.5-.9-.5-1.4 0-.5.2-1 .6-1.4.3-.4.8-.6 1.3-.6s1 .2 1.4.6.6.8.6 1.4z' })
  );
};

var LoadingIndicator = (_dec = (0, _styling.styled)((0, _styling.StyleSheet)({
  container: (0, _extends3.default)({}, _styleMixins2.default.suffixElements, {
    pointerEvents: 'none'
  }),
  icon: (0, _extends3.default)({}, _styleMixins2.default.iconSize, {
    animation: '1.5s linear reverse infinite ' + (0, _styling.keyframes)({
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    })
  })
})), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoadingIndicator, _Component);

  function LoadingIndicator() {
    (0, _classCallCheck3.default)(this, LoadingIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingIndicator.__proto__ || (0, _getPrototypeOf2.default)(LoadingIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoadingIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          styles = _props.styles,
          Icon = _props.Icon,
          props = (0, _objectWithoutProperties3.default)(_props, ['styles', 'Icon']);

      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({
          title: 'Loading options...'
        }, props, styles.with('container')(props)),
        _react2.default.createElement(Icon, styles('icon'))
      );
    }
  }]);
  return LoadingIndicator;
}(_react.Component), _class2.defaultProps = { style: {}, Icon: SpinnerIcon }, _temp)) || _class);
process.env.NODE_ENV !== "production" ? LoadingIndicator.propTypes = {
  styles: _propTypes2.default.func,
  Icon: _customPropTypes.ComponentPropType
} : void 0;
exports.default = LoadingIndicator;